// helpers
import DTM, { PAGE_TYPE } from 'shared/helpers/DTM';

// constants
import { DEFAULT_CHANNEL } from 'shared/helpers/DTM/constants';

export const onPageLoad = (slug: string) => {
  const data: { [key: string]: string | boolean } = {};

  data.pagename = `${PAGE_TYPE.CMSPAGE}:${slug}`;
  data.pagetype = `${PAGE_TYPE.CMSPAGE}`;
  data.channel = `${DEFAULT_CHANNEL}`;

  DTM.onPageLoad(data);
};
